import { Address } from '../../global/dto/shared-data-model';
import { YesNoIndicators } from '../../global/models/api-model';
import { BaseBlockModel } from '../../global/models/tcsm-block-models';
import { Gps } from '../arc/models/arc-epi-props';

export enum PodContent {
	CONTENT = 'content',
	NOT_ENROLLED = 'not_enrolled',
}


export interface Db {
	plan_title: string;
	benefits_effective_date: string;
	monthly_pension: string;
	retirement_date: string;
	payment_start_date: string;
	medical_deduction_amount: string;
	catastrophic_deduction_amount: string;
	tax_withheld: string;
	years_of_credited_service: number;
	medicare_credited_service: number;
	highest_average_compensation: number;
	beneficiaries: any[];
	content_path: string;
	show_prsb_beneficiary_message: string;
}

export interface Dc {
	title: string;
	as_of_date: string;
	status: string;
	total_balance: number;
	employer_base: number | string;
	employer_match: number | string;
	employer_match_type: string;
	total_withdrawal: number;
	withdrawal_date: string;
	benefit_deferral_amount: string;
	deferral_percent: string;
	loan_count: number;
	total_loan_amount: number;
	content_path: string;
	deferral_flag: boolean;
	benefit_pretax_amount?: string;
	benefit_pretax_percent?: string;
	benefit_roth_amount?: string;
	benefit_roth_percent?: string;
	benefit_aftertax_amount?: string;
	benefit_aftertax_percent?: string;
}



export interface DbData {
	content: PodContent;
	data: Db[];
	db_annual_statement: YesNoIndicators;
	db_annual_statement_path: string;
	db_estimate_link: YesNoIndicators;
	db_estimate_link_path: string;
	db_estimate_request: YesNoIndicators;
	db_estimate_request_path: string;
	show_pod: YesNoIndicators;
}

export interface Annuity {
	source: string;
	plan_name: string;
	policy_id: string;
	in_distribution: boolean;
	current_fund_value: number;
	surrender_value: number;
}

export interface AnnuityData {
	show_pod: YesNoIndicators;
	content: string;
	plan_details: string;
	data: Annuity[];
}

export interface ContactData {

}
export interface DcData {
	content: PodContent;
	data: Dc;
	show_pod: YesNoIndicators;
	as_of_date: YesNoIndicators;
	withdrawal: YesNoIndicators;
	withdrawal_date: YesNoIndicators;
	loans: YesNoIndicators;
	employer_base: YesNoIndicators;
	employer_match: YesNoIndicators;
	employer_contribution: YesNoIndicators;
}

export interface Dental {
	description: string;
	content_path: string;
	beneficiaries: string[];
}

export interface DentalData {
	show_pod: YesNoIndicators;
	content: PodContent;
	show_beneficiaries: YesNoIndicators;
	data: Dental;
}

export interface DetailContent {
	plan_details: string,
	content_path: string,
}
export interface DisabilityData {
	disability_pod: YesNoIndicators,
	disability_rd: YesNoIndicators,
	show_long_term_disability: YesNoIndicators,
	disability_std_content: PodContent;
	disability_ltd_content: PodContent;
	short_term_plan_details: string;
	short_term_content_path: string;
	long_term_plan_details: string;
	long_term_content_path: string;
	short_term_disabilities: DetailContent[],
	long_term_disabilities: DetailContent[],
}

export interface EmploymentItem {
	title: string;
	address: Address;
	job_title: string;
}

export interface EmploymentData {
	show_pod: YesNoIndicators;
	data: EmploymentItem[];
}

export interface Life {
	type: string;
	policy_id: string;
	coverage_amount: number;
	effective_date: string;
	plan_details: string;
	content_path: string;
	premium: string;
	frequency: string;
	paid_through: string;
	premium_paid_by: string;
	beneficiaries: any[];
	product_type: string;
	plan_description: string;
	ftj_link: string;
	policy_name: string;
}

export enum LifeTypes {
	LIFEGROUP = 'Group Life',
}

export interface LifePension {
	policy_name: string;
	coverage_amount: number,
	content_path: string;
	plan_details: string;
	beneficiaries: any[];
	product_type: string;
	plan_description: string;
	policy_id: string;
	type: string;
	ftj_link: string;

}

export interface LifeData {
	show_pod: YesNoIndicators;
	show_life_pensions: boolean;
	data: Life[];
	pension_life_data: LifePension[];
	content: PodContent;
}

export interface Medical {
	plan_id: string;
	description: string;
	content_path: string;
	beneficiaries: string[];
}
export interface MedicalData {
	show_pod: YesNoIndicators;
	content: PodContent;
	show_beneficiaries: YesNoIndicators;
	data: Medical;

}

export interface Rsvp {
	title: string;
	as_of_date: string;
	status: string;
	total_balance: number;
	employer_base: number | string;
	employer_match: number | string;
	employer_match_type: string;
	employer_base_type: string;
	total_withdrawal: number;
	withdrawal_date: string;
	deferral_percent: number;
	loan_count: number;
	total_loan_amount: number;
	plan_details: string;
	fidelity_link_path: string;
	benefit_deferral_amount: string;
	deferral_amount_flag: YesNoIndicators;
	deferral_flag: boolean;
	benefit_pretax_amount?: string;
	benefit_pretax_percent?: string;
	benefit_roth_amount?: string;
	benefit_roth_percent?: string;
	benefit_aftertax_amount?: string;
	benefit_aftertax_percent?: string;
}

export interface RsvpData {
	show_pod: YesNoIndicators;
	content: PodContent;
	data: Rsvp;
	employer_base: string;
	employer_match: string;
}

export interface PodEmploymentHistoryData {
	data: {
		active_cpg_employee: YesNoIndicators,
		former_cpg_employee: YesNoIndicators,
		active_church_employee: YesNoIndicators,
		former_church_employee: YesNoIndicators,
	}
}

export interface MyCpgPods {
	annuity_data: AnnuityData;
	contact_data: ContactData;
	db_data: DbData;
	dc_data: DcData;
	dental_data: DentalData;
	disability_data: DisabilityData;
	employment_data: EmploymentData;
	life_data: LifeData;
	medical_data: MedicalData;
	rsvp_data: RsvpData;
	status: string;
	total_life_benefit_value: number;
	employment_history_data?: PodEmploymentHistoryData;
	ghl_bill_payer: string;
	pension_bill_payer: string;
}

export interface PensionBillingInfo {
  account_number: string;
  account_type: string;
  person_client_number: string;
}

export interface GhlBillingInfo {
  account_number: string;
  account_type: string;
  person_client_number: string;
  billing_account_name: string;
}

export interface MyCpgPodsState {
	pods: MyCpgPods,
	podsLoaded: boolean,
	podsError: boolean,
  ghlInfo?: GhlBillingInfo[],
  ghlInfoLoaded?: boolean,
  ghlInfoError?: boolean,
	pensionInfo?: PensionBillingInfo[],
  pensionInfoLoaded?: boolean,
  pensionInfoError?: boolean,
}

export enum MyCpgPodsActions {
	SET_MYCPG_PODS = 'SET_MYCPG_PODS',
	SET_MYCPG_ERROR = 'SET_MYCPG_ERROR',
  SET_GHL_BILLING_INFO = 'SET_GHL_BILLING_INFO',
  SET_GHL_BILLING_INFO_ERROR = 'SET_GHL_BILLING_INFO_ERROR',
  SET_PENSION_BILLING_INFO = 'SET_PENSION_BILLING_INFO',
  SET_PENSION_BILLING_INFO_ERROR = 'SET_PENSION_BILLING_INFO_ERROR',
}

export enum MyCpgPodsTypes {
	PENSION = 'PENSION',
	DC = 'DC',
	RSVP = 'RSVP',
	HEALTH = 'HEALTH',
	LIFE = 'LIFE',
	ANNUITY = 'ANNUITY',
	DISABLE = 'DISABLE',
	EMPLOYMENT = 'EMPLOYMENT',
}

export interface BannerAd {
	imageUrl: string;
	imageAltText: string;
	title: string;
	subtitle: string;
	buttonText: string;
	link: string;
	startDate: string;
	endDate: string;
}

export interface NewHireMemberPendingEnrollment {
	id: number;
	employment_id: number;
	complete_by?: string;
	employer: {
		name: string;
		client_number: string;
	};
}


export interface MyCpgPodsSettings {

	heroImage: string;
	heroImageAltText: string;
	heroTitle: string;
	heroSubtitle: string;
	ctaButtonText: string;
	ctaLink: string;
	bannersArea: BannerAd[];
	seeMoreLinkText: string;
	podGridTitle: string;
	planDetailButtonLabel: string;
	podGridHelperText: string;
	guidesResourcesHeader: string;
	guidesResourcesBlocks: BaseBlockModel[];
	bottomMessage: string;
	podErrorMessage: string;
	noPlanTitle: string;
	noPlanMessage: string;
	hidePods: boolean;
	hidePodMessage: string;
	pendingEnrollmentBannerDescription: string;
	pendingEnrollmentBannerUrlText: string;
	pendingEnrollmentBannerTitle: string;
	participantPendingEnrollmentBannerDescription: string;
	participantPendingEnrollmentBannerUrlText: string;
	participantPendingEnrollmentBannerTitle: string;
	noAccessMessage: string;
	enableFtj: boolean;
	activeCpgEmployeeOnlyMessage: string;
	activeCpgAndChurchEmployeeMessage: string;
	formerCpgEmployeeOnlyMessage: string;
	formerCpgEmployeeActiveChurchOnlyMessage: string;
	// sidebar
	latestUpdatesHeader: string;
	sidebarInfoBoxHeader: string;
	sidebarInfoBoxContent: string;

	//Pension Pod
	pensionPlanPodTitle: string;
	pensionPlanDcPodTitle: string;
	pensionPlanDcDetailTitle: string;
	multipleDbPlansMessage: string;
	noDcPlanMessage: string;
	pensionPlanPodFooterContent: string;
	creditedServiceLabel: string;
	highestAvgCompensationLabel: string;
	pensionCalculatorButtonText: string;
	retirementDateLabel: string;
	paymentEffectiveDateLabel: string;
	medicalDeductionLabel: string;
	coverageReductionLabel: string;
	totalTaxWithholdingLabel: string;
	benefitEffectiveDateLabel: string;
	monthlyPensionBenefitLabel: string;
	noPensionPlanText: string;
	haveBothDcDbPlanText: string;
	totalDbSumLabel: string;
	dcBalanceDateLabel: string;
	dbBalanceDateLabel: string;
	balanceDateLabel: string;
	pensionPlanDetailTitle: string;
	creditedServicePensionYearLabel: string;
	creditedServiceMedicareYearLabel: string;
	pensionTotalLabel: string;
	planDetailsLabel: string;
	dcPlanTitle: string;
	statusLabel: string;
	dcPlanDetailTitle: string;
	employerBaseLabel: string;
	employerMatchLabel: string;
	deferralAmountLabel: string;
	deferralPercentLabel: string;
	afterTaxDeferralAmountLabel: string;
	afterTaxDeferralPercentLabel: string;
	rothDeferralAmountLabel: string;
	rothDeferralPercentLabel: string;
	deferralAmountTooltip: string;
	deferralPercentTooltip: string;
	afterTaxDeferralAmountTooltip: string;
	afterTaxDeferralPercentTooltip: string;
	rothDeferralAmountTooltip: string;
	rothDeferralPercentTooltip: string;
	numberOfLoansLabel: string;
	totalLoanAmountLabel: string;
	withdrawalLabel: string;
	withdrawalDateLabel: string;
	pensionGpsTitle: string;
	pensionGps: Gps[];
	dcGpsTitle: string;
	dcGps: Gps[];
	seeMoreHelperText: string;
	creditedServiceHelper: string;
	medicareServiceHelper: string;
	hacHelper: string;
	beneficiariesTitle: string;
	pensionBenefitHelper: string;
	medicalDeductionHelper: string;
	totalTaxHelper: string;
	coverageReductionHelper: string;
	employerBaseHelper: string;
	employerMatchHelper: string;
	deferralAmountHelper: string;
	deferralPercentHelper: string;
	numberOfLoansHelper: string;
	learnMoreText: string;
	dcPlanDetailMessage: string;
	dbPlanNotEnrolledMessage: string;
	dcPlanNotEnrolledMessage: string;
	healthPlanNotEnrolledMessage: string;
	annuityPlanNotEnrolledMessage: string;
	rsvpPlanNotEnrolledMessage: string;
	disabilityPlanNotEnrolledMessage: string;
	lifePlanNotEnrolledMessage: string;
	activeLayDBOnlyMessage: string;
	annuityPlanFtjLinkText: string;
	annuityPlanFtjRedirect: string;
	//Health Pod
	healthPlanTitle: string;
	medicalLabel: string;
	noMedicalText: string;
	dentalLabel: string;
	noDentalText: string;
	healthPlanDetailTitle: string;
	healthDetailDescription: string;
	medicalNotEnrolledText: string;
	dentalNotEnrolledText: string;
	healthGpsTitle: string;
	healthGps: Gps[];
	dependentsLabel: string;
	noDependantsLabel: string;

	//Annuity Pod
	annuityPlanTitle: string;
	currentValueLabel: string;
	surrenderValueLabel: string;
	noAnnuityPlanText: string;
	multipleAnnuityPlanText: string;
	annuityGpsTitle: string;
	annuityGps: Gps[];
	distributionMessage: string;
	distributionMessageID3: string;
	newAnnuityPodMessage: string;
	//Annuity Details
	annuityPlanDetailTitle: string;
	annuityPlanDetailCurrentValueLabel: string;
	annuityPlanDetailSurrenderAmountLabel: string;
	annuityPlanDetailAdditionalInfoText: string;
	annuityPlanDetailAdditionalInfoTextID3: string;
	newAnnuityPlanMessage: string;
	newAnnuityPlanMessageID3: string;
	//RSVP Pod
	rsvpPlanTitle: string;
	rsvpNoPlanText: string;
	rsvpPlanDetailTitle: string;
	rsvpDeferralAmountLabel: string;
	rsvpDeferralPercentageLabel: string;
	rsvpFidelityTitle: string;
	rsvpGpsTitle: string;
	rsvpGps: Gps[];
	outstandingLoanAmountLabel: string;

	//Disability Plan
	disabilityPlanTitle: string;
	shortOnlyText: string;
	longOnlyText: string;
	bothLongAndShortText: string;
	noDisText: string;
	disabilityDetailTitle: string;
	shortTermSectionTitle: string;
	longTermSectionTitle: string;
	disabilityGpsTitle: string;
	disabilityGps: Gps[];

	//Life Plan
	lifePlanTitle: string;
	lifePlansTitle: string;
	lifePlanPodFooterContent: string;
	noLifePlanText: string;
	lifeInsurranceCoverageLabel: string;
	groupLifeCoverageLabel: string;
	benefitCoverageAmountLabel: string;
	newIndividualLifePlanMessage: string;
	newIndividualLifePlanPodMessage: string;
	lifePlanDetailTitle: string;
	policyNumberLabel: string;
	insuranceLabel: string;
	premiumLabel: string;
	paidThroughLabel: string;
	effectiveDateLabel: string;
	effectiveDateTooltip: string;
	paidByLabel: string;
	beneficiariesLabel: string;
	beneficiariesValue: string;
	beneficiariesStatement: string;
	noBeneficiaries: string;
	lifePlanFtjLinkText: string;
	lifePlanFtjRedirect: string;
	lifeGpsTitle: string;
	lifeGps: Gps[];

	//Employment
	employmentPodTitle: string;
	addressLabel: string;
	employmentHistoryTitle: string;
	employmentHistoryDescription: string;
	employmentPodDetailLinkString: string;

	// Brand
	brandImage: string;
	brandImageAltText: string;
	bannerImage: string;
	bannerImageLink: string;
	bannerImageAltText: string;

	// Mycpg Billing
	mycpgBillingTitle: string;
	billingPageInstructions: string;
	acctNumHeader: string;
	acctNameHeader: string;
	medicalTrustLink: string;
	hippaNoticeLink: string;
}
